export var HashCryptographyTypes;
(function (HashCryptographyTypes) {
    HashCryptographyTypes[HashCryptographyTypes["MD5"] = 0] = "MD5";
    HashCryptographyTypes[HashCryptographyTypes["SHA1"] = 1] = "SHA1";
    HashCryptographyTypes[HashCryptographyTypes["SHA256"] = 2] = "SHA256";
    HashCryptographyTypes[HashCryptographyTypes["SHA384"] = 3] = "SHA384";
    HashCryptographyTypes[HashCryptographyTypes["SHA512"] = 4] = "SHA512";
})(HashCryptographyTypes || (HashCryptographyTypes = {}));
;
